'use strict';

const beforePrint = () => {
	const isModalOpen = $('.modal').not('.is-hidden').length === 1;

	if (isModalOpen) {
		$('body').addClass('non-print');
	}
};

const afterPrint = () => {
	$('body').removeClass('non-print');
};

window.addEventListener('beforeprint', () => beforePrint());
window.addEventListener('afterprint', () => afterPrint());
